import pollSVG from './icons/poll.svg';

export default pollSVG;
